import React from 'react';
import { IInfluencerReport } from '../../../../../../model/measure/IInfluencerReport';
import { User } from '../../../../../../model/user/User';
import { DetailedPerPlatformFilter } from './DetailedPerPlatformFilter';
import { DetailedPerPlatformTable } from './DetailedPerPlatformTable';

interface IProps {
    influencerData: IInfluencerReport[];
    selectedPlatformId: { id: string };
    influencers: User[] | undefined;
    setSelectedPlatformId: React.Dispatch<React.SetStateAction<{ id: string }>>;
    isLoading?: boolean;
}

export const DetailedPerPlatform = ({
    influencerData,
    selectedPlatformId,
    setSelectedPlatformId,
    influencers,
    isLoading = false,
}: IProps) => {
    return (
        <>
            <DetailedPerPlatformFilter
                influencers={influencers}
                selectedPlatformId={selectedPlatformId}
                setSelectedPlatformId={setSelectedPlatformId}
            />
            <DetailedPerPlatformTable influencerData={influencerData} isLoading={isLoading} />
        </>
    );
};
